<template>
  <div class="p-8" style="padding-bottom: 0;">
    <!-- 资产 -->
    <div class="bor-rad-10 s_over_h p-8" :style="'background: linear-gradient(90deg, '+data.style.bgColor.left+' 0%, '+data.style.bgColor.right+' 100%);'">
      <img class="width100 m-b-15" src="@/assets/images/user/top1.png" alt="">
      <div class="s_flex_center width100 bor-rad-10 p-b-8 p-t-5" :style="'background:'+data.style.assetsBgColor">
        <template v-for="(items,indexs) in data.data" :key='indexs' >
          <div class="flex_1 text-ac" v-if='items.show' :style='"color:"+data.style.color'>
            <div>
              <p class="fz-20">100</p>
              <p class="fz-13">{{items.name}}</p>
            </div>
          </div>
        </template>
      </div>
      <!-- 累计红包 -->
     <div class="p-t-10 bor-rad-10 p-b-10 m-t-10 p-r-10" :style="'background:'+data.style.assetsBgColor">
        <p class="p-l-8 fz-15 s_font_b"  :style='"color:"+data.style.color'>{{data.style.grandTitle?data.style.grandTitle:'累计红包'}}</p>
        <div class="p-l-8">
            <a-progress :percent="50" :show-info="false" :strokeColor="data.style.color" :height="50"/>
        </div>
        <p class="fz-12 p-l-8" :style='"color:"+data.style.color'>还差0.1元即可自动转账</p>
      </div>
      <!-- 权益 -->
      <div class="p-t-10">
        <p class="p-l-8 fz-15 s_font_b" v-if='data.style.show' :style='"color:"+data.style.color'>{{data.style.privilegeTitle}}</p>
        <div class="s_flex_bian p-t-10  p-b-10">
          <template v-for="(item,index) in data.params" :key="index">
            <div class="flex_1" :hidden='item.hidden' :style='"color:"+data.style.color'>
              <img class="height-50 s_mauto" style="width:50px;display:block"
                :src="item.imgUrl?info.picdomain+item.imgUrl : require('@/assets/images/user/tq'+index+'.png')" alt="">
              <p class="text-ac fz-12 m-t-5 s_cfff">{{item.name || '特权名称'}}</p>
            </div>
          </template>
        </div>
        <p class="fz-12 text-ac" :style='"color:"+data.style.color'>关于会员等级与特权>></p>
      </div>
    </div>
  </div>
</template>
<script>
  import { ref } from "vue";
  import store from "@/store";
  export default {
    props: { data: Object },
    name: "assets",
    setup(props) {
      return {
        info: ref(store.state.user.info)
      };
    }
  };
</script>
<style>
</style>